<mat-form-field
  class="custom-mat-form-field"
  [class.custom-search-dialog-width]="dialogMode">
  <input
    #search
    matInput
    type="text"
    [placeholder]="placeholder"
    [(ngModel)]="query"
    [matAutocomplete]="autocomplete ?? auto"
    (ngModelChange)="innerQueryChange$.next(query)"
    (keyup.enter)="innerQueryChange$.next(query)">

  <button
    *ngIf="query; else closeIcon"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="query = ''; innerQueryChange$.next(query)">
    <mat-icon>close</mat-icon>
  </button>
  <ng-template #closeIcon>
    <button
      matSuffix
      mat-icon-button
      aria-label="Search"
      (click)="innerQueryChange$.next(query)">
      <mat-icon>manage_search</mat-icon>
    </button>
  </ng-template>
</mat-form-field>

<mat-autocomplete #auto="matAutocomplete">
</mat-autocomplete>
